import React from 'react';

const StockList = ({ title, stocks, type, onSelectTicker }) => {
  const color = type === 'gainer' ? '#00ff88' : type === 'loser' ? '#ff4444' : '#00d4ff';
  const borderColor = type === 'gainer' ? 'rgba(0,255,136,0.18)' : type === 'loser' ? 'rgba(255,68,68,0.18)' : 'rgba(0,212,255,0.18)';

  return (
    <div style={{background:'linear-gradient(135deg,rgba(15,30,60,0.65),rgba(20,35,65,0.45))',backdropFilter:'blur(10px)',border:`1px solid ${borderColor}`,borderRadius:'16px',padding:'1.25rem'}}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:'1rem'}}>
        <h3 style={{fontSize:'1.1rem',fontWeight:800,color,margin:0}}>{title}</h3>
        <span style={{fontSize:'0.65rem',color:'#475569',background:'rgba(0,212,255,0.06)',padding:'2px 8px',borderRadius:'12px',border:'1px solid rgba(0,212,255,0.1)'}}>
          {stocks.length} stocks
        </span>
      </div>
      <div style={{display:'flex',flexDirection:'column',gap:'0.4rem'}}>
        {stocks.map((stock, idx) => (
          <div key={idx}
            onClick={() => onSelectTicker(stock.ticker)}
            style={{display:'flex',alignItems:'center',gap:'0.75rem',padding:'0.55rem 0.75rem',background:'rgba(255,255,255,0.02)',borderRadius:'8px',cursor:'pointer',borderLeft:`3px solid ${color}`,transition:'background 0.15s'}}
            onMouseEnter={e => e.currentTarget.style.background='rgba(255,255,255,0.05)'}
            onMouseLeave={e => e.currentTarget.style.background='rgba(255,255,255,0.02)'}
            title={`Analyze ${stock.ticker}`}
          >
            <div style={{fontSize:'0.7rem',color:'#475569',width:'16px',textAlign:'center',flexShrink:0}}>{idx+1}</div>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontSize:'0.9rem',fontWeight:800,color:'#f8fafc'}}>{stock.ticker}</div>
              <div style={{fontSize:'0.65rem',color:'#475569',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{stock.name}</div>
              <div style={{fontSize:'0.6rem',color:'#374151'}}>
                {stock.volume > 0 ? `Vol: ${stock.volume>=1000000?`${(stock.volume/1000000).toFixed(1)}M`:stock.volume>=1000?`${(stock.volume/1000).toFixed(0)}K`:stock.volume}` : ''}
              </div>
            </div>
            <div style={{textAlign:'right',flexShrink:0}}>
              <div style={{fontSize:'0.9rem',fontWeight:700,color:'#f8fafc'}}>${stock.price?.toFixed(2)}</div>
              <div style={{fontSize:'0.8rem',fontWeight:700,color}}>
                {stock.changePercent>=0?'▲':'▼'} {Math.abs(stock.changePercent)?.toFixed(2)}%
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StockList;
